import { useEffect } from "react";
import { Typography, Stack, styled, InputBase, Box } from "@mui/material";
import { useAppSelector } from "../../hooks";
import OtherAccountInfo from "./otherAccountInfo";
import { useNavigate } from "react-router-dom";
import { LoginForgetContent } from "../../SharedComponents/contents";

const LoginRegFooter = () => {
  const navigate = useNavigate();
  // const LOGIN_CONTENTS: any = useAppSelector(
  //   (state) => state?.loginForgetPageContent?.loginForgetPageContent
  // );
  const LOGIN_CONTENTS: any = LoginForgetContent();
  const LOGIN_FOOTER = LOGIN_CONTENTS?.entry?.login?.footer;
  const userCompanyName = useAppSelector((state) => state?.user?.companyName);
  const logedUserCompany = userCompanyName
    ? userCompanyName
    : localStorage?.getItem("companyName");

  return (
    <Stack className="loginbottomSections">
      <Box className="needHelp">
        <Typography className="title" component="h2">
          {LOGIN_FOOTER?.help_label}
        </Typography>
        <Typography
        component="a"
        aria-label={ LOGIN_FOOTER?.contact_customer_service_label+" opens in new tab"}
        target="_blank"
        href={"https://www.brightspeed.com/help/contact/"}
        rel={"noopener,noreferrer"}
        >
          {LOGIN_FOOTER?.contact_customer_service_label}
        </Typography>
        <Typography
          component="a"
          target="_blank"
          aria-label={ LOGIN_FOOTER?.account_help_label+" opens in new tab"}
          href={"https://www.brightspeed.com/help/account/"}
          rel={"noopener,noreferrer"}
        >
          {LOGIN_FOOTER?.account_help_label}
        </Typography>
      </Box>
      {/* <Box className="otherAccounts">
        <Typography className="title" component="h2">
          {LOGIN_FOOTER?.other_accounts_label}
        </Typography>
        <Box>
          <OtherAccountInfo />
        </Box>
      </Box> */}
    </Stack>
  );
};
export default LoginRegFooter;
